import { useContext } from 'react';
import { EmployeeSidePanelContext } from './EmployeeSidePanelProvider';

export function useEmployeeSidePanel() {
  const context = useContext(EmployeeSidePanelContext);
  if (!context) {
    throw new Error('useEmployeeSidePanel must be used within an EmployeeSidePanelProvider');
  }
  return context;
}
